import { provideKeycloak, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, withAutoRefreshToken, AutoRefreshTokenService, UserActivityService, createInterceptorCondition, IncludeBearerTokenCondition } from 'keycloak-angular';
import { environment } from '../../environments/environment';

const apiBaseCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: new RegExp(`^(${environment.apiBase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})(\/.*)?$`, 'i'),
    bearerPrefix: 'Bearer'
});

export const provideKeycloakAngular = () =>
    provideKeycloak({
        config: environment.keycloak,
        initOptions: {
            onLoad: 'login-required',
            flow: 'standard',
            // Remove redirectUri to let Keycloak use the current URL
            // This way it redirects back to the page you were trying to access
            checkLoginIframe: false,
            scope: 'openid email profile roles'
        },
        features: [
            withAutoRefreshToken({
                onInactivityTimeout: 'logout',
                sessionTimeout: 60000 * 30 // 30 minutes of inactivity before logout (in milliseconds)
            })
        ],
        providers: [
            AutoRefreshTokenService,
            UserActivityService,
            {
                provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
                useValue: [apiBaseCondition]
            }
        ]
    });
